module.exports = __webpack_public_path__ + "img/cim@2x.50a4c73b.png";